import { useState } from "react";
import { useDispatch } from "react-redux";
import { setPayloadData } from "@store/slices/globalState";
import { setAnalytics } from "@actions/setAnalyticsData";
import { sampleAnalytics } from "@utils/index";
import useSWR from "swr";

interface UseVariantStateProps {
  initial_variant: string;
  initial_fuel_type: string;
}

const fetcher = (...args: Parameters<typeof fetch>) =>
  fetch(...args).then((res) => res.json());

const swrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false
};

export const useGetRegistrationYears = () => {
  const url = `${process.env.SDUI_API_SERVICE}/mmv?vehicleType=car&journey=freshCar&mmvVersion=old`;
  const { data, error } = useSWR(url, fetcher, swrOptions);

  return {
    registrationYears: data?.registration_years || {},
    isLoading: !error && !data,
    error
  };
};

export const useVariantState = ({ initial_variant, initial_fuel_type }: UseVariantStateProps) => {
  const dispatch = useDispatch();
  const [currentStateForVariant, setCurrentStateForVariant] = useState<any>(
    initial_variant ? { variant_name: initial_variant } : ""
  );
  const [currentStateForFuelType, setCurrentStateForFuelType] = useState<string>(
    initial_fuel_type || ""
  );

  const handleVariantClick = (selectedFuelType: any, selectedVariant: any) => {
    if (selectedFuelType) {
      setCurrentStateForFuelType(selectedFuelType);
      sampleAnalytics("action", "tap_btn", "tap_btn_fuel_type_selected", {
        fuel_type: selectedFuelType
      });
      setAnalytics({
        fuel_type: selectedFuelType
      });
      dispatch(
        setPayloadData({
          fuel_type: selectedFuelType
        })
      );
    }
    if (selectedVariant) {
      setCurrentStateForVariant(selectedVariant);
      sampleAnalytics("action", "tap_btn", "tap_btn_variant_selected", {
        variant_name: selectedVariant?.variant_name,
        variant_ekey: selectedVariant?.variant_ekey
      });
      setAnalytics({
        variant: selectedVariant?.variant_name,
        variant_ekey: selectedVariant?.variant_ekey
      });
      dispatch(
        setPayloadData({
          variant: selectedVariant?.variant_name,
          variant_ekey: selectedVariant?.variant_ekey
        })
      );
    }
  };

  return {
    currentStateForVariant,
    currentStateForFuelType,
    setCurrentStateForVariant,
    setCurrentStateForFuelType,
    handleVariantClick
  };
}; 